import LicenseValidator from '../components/LicenseValidator'

export default LicenseValidator;